module.exports = __webpack_public_path__ + "static/media/lock.a0cd68a4.svg";